<div
  class="validate-bottom-action-container"
  [ngClass]="[isHideAssignButton ? 'validate-bottom-action-container_hidden' : '', isBottomScrolled ? 'scrolled' : '']"
  [@slideInOut]>
  <div class="validate-bottom-action-container__toggle">
    <button (click)="toggleAssignButton()">
      <img src="assets/icons/icon-down-arrows.svg" alt="" />
    </button>
  </div>

  @if (assignLoader) {
    <pdq-progress-bar mode="indeterminate" size="small"></pdq-progress-bar>
  }
  <div class="action-object">
    @if (false) {
      <div class="action-object__item">
        <img alt="" src="assets/images/cta_bar/plus_icon.svg" />
      </div>
    }
    <div
      class="action-object__item action-object-text"
      [ngClass]="{
        'action-object-text__disabled': assignLoader,
      }"></div>
  </div>
  <div class="action-subject">
    <div
      class="action-subject__item action-subject-text"
      [ngClass]="{
        'action-subject-text__disabled': assignLoader,
      }">
      @if (this.selectedValidOrders.length > 0) {
        <span>
          <span class="heavy">{{ this.selectedValidOrders.length }} </span>verified
          {{ this.selectedValidOrders.length > 1 ? 'orders' : 'order' }}
          selected
        </span>
      } @else {
        <span class="heavy">{{ isCapped() ? `${countValidatedOrders}+` : countValidatedOrders }}</span> verified
        {{ countValidatedOrders > 1 ? 'orders' : 'order' }}
      }
      @if (isOrdersUpdating) {
        <div class="updating-text">Please wait for orders to finish updating</div>
      }
    </div>
    <div class="action-subject__item action-subject-button">
      <pdq-button variant="primary" [disabled]="assignLoader || isOrdersUpdating" (onClick)="sendOrders()">
        Approve & proceed
      </pdq-button>
    </div>
  </div>
</div>
